import { jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBoxSaleGroupCosmeticBrandResponse } from './admin-box-sale-group-cosmetic-brand.response';

@jsonObject
export class AdminBoxSaleGroupCosmeticResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(Number)
  public readonly amount?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(Number)
  public readonly remainingQuantity?: Nillable<number>;

  @jsonMember(AdminBoxSaleGroupCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminBoxSaleGroupCosmeticBrandResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featureFile?: Nillable<MultimediaResponse>;
}
